// extracted by mini-css-extract-plugin
export default {"container":"SocietiesList_container__QQGaH","content":"SocietiesList_content__+-qJn","societyImage":"SocietiesList_societyImage__JarvC"};